<template>
    <div class="page-container flex flex-direction " :class="show ? '':'flex-sub'">
        <div v-if="state !== 0" :class="state | status_color" class="status flex margin-bottom">
            <div class="text-sm text-white">{{ state | status }}</div>
            <div v-if="state === -2" class="text-sm margin-left-xs text-white">：{{ reason }}</div>
        </div>
        <div class="flex flex-direction flex-sub">
            <div class="document flex flex-direction radius">
                <div class="flex flex-direction ">
                    <div class="document-name flex align-center justify-between padding-lr-sm">
                        <div class="title text-df text-red text-bold">
                            <i class="el-icon-folder-opened text-bold text-red margin-right-xs"></i>通知
                        </div>
                        <div v-if="!readonly" class="flex align-center">
                            <el-button class="btn  radius" type="warning" @click="addFiles(false)">创建子文件夹
                            </el-button>
                            <upload-file class="margin-lr-xs" :params="{pid: pid,did : ''}" multiple @uploadFile="uploadFile">
                                <el-button slot="upload" class="btn small radius" size="small" type="primary">上传</el-button>
                            </upload-file>
                            <div class="btn small radius bg-blue margin-right-xs" style="position: relative">上传文件夹
                                <upload-file name="notice" :params="{pid: pid,did : 0,pdid:0}" folder @uploadFile="uploadFile"></upload-file>
                            </div>
                            <el-button class="btn small bg-red light radius" size="small" @click="downloadFiles(0)" v-if="power">
                                下载
                            </el-button>
                            <el-button class="btn small radius" size="small" @click="expand = !expand">
                                {{ expand ? '收起' : '展开' }}
                            </el-button>
                        </div>
                    </div>
                    <el-divider v-if="(lists.enclosure.length || lists.folder.length) && expand"></el-divider>
                    <div class="margin-left-xl flex flex-direction" v-if="expand">
                        <div v-for="(file,position) in lists.enclosure" :key="position" class="margin-left-sm file flex align-center justify-between padding-right-xl">
                            <div class="flex-twice flex align-start justify-start">
                                <div class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                    {{ file.name }}
                                </div>
                            </div>
                            <div class="text-sm flex-sub">{{ file.create_time }}</div>
                            <el-button v-if="!readonly" type="text" @click="changeFileName(file)">修改</el-button>
                            <el-button v-if="!readonly" type="text" @click="delFile(file)">
                                <i class="el-icon-delete text-orange"></i></el-button>
                        </div>
                        <div v-for="(item1,index1) in lists.folder" :key="index1" class="flex flex-direction">
                            <el-divider v-if="(!lists.enclosure.length && index1 !==0 ) || lists.enclosure.length"></el-divider>
                            <div class="document-name flex align-center justify-between padding-lr-sm">
                                <div class="title text-df text-orange">
                                    <i class="el-icon-folder-opened text-orange text-bold margin-right-xs"></i>{{ item1.name
                                    }}
                                </div>
                                <div v-if="!readonly" class="flex align-center">
                                    <el-button class="btn  radius" type="warning" @click="addFiles({parent_id:item1.id})">
                                        创建子文件夹
                                    </el-button>
                                    <el-button class="btn small radius" size="small" type="primary" @click="addFiles(item1)">
                                        修改
                                    </el-button>
                                    <upload-file class="margin-lr-xs" :params="{pid: pid,did : item1.id}" multiple @uploadFile="uploadFile">
                                        <el-button slot="upload" class="btn small radius" size="small" type="primary">上传</el-button>
                                    </upload-file>
                                    <div class="btn small radius bg-blue margin-right-xs" style="position: relative">上传文件夹
                                        <upload-file name="notice" :params="{pid: pid,did : 0,pdid:item1.id}" folder @uploadFile="uploadFile"></upload-file>
                                    </div>
                                    <el-button class="btn small radius" size="small" type="danger" @click="delItemFiles(item1)">
                                        删除
                                    </el-button>
                                    <el-button class="btn small bg-red light radius" size="small" @click="downloadFiles(item1.id)" v-if="power">
                                        下载
                                    </el-button>
                                    <el-button class="btn small radius" size="small" @click="item1.expand = !item1.expand">
                                        {{ item1.expand ? '收起' : '展开' }}
                                    </el-button>

                                </div>
                            </div>
                            <el-divider v-if="(item1.enclosure.length || item1.folder.length) && item1.expand"></el-divider>
                            <div class="margin-left-xl flex flex-direction" v-if="item1.expand">
                                <div class="margin-left-sm flex flex-direction">
                                    <div v-for="(file,position) in item1.enclosure" :key="position" class="file flex align-center justify-between padding-right-xl">
                                        <div class="flex-twice flex align-start justify-start">
                                            <div :href="file.file_url" class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                                {{ file.name }}
                                            </div>
                                        </div>
                                        <div class="text-sm flex-sub">{{ file.create_time }}</div>
                                        <el-button v-if="!readonly" type="text" @click="changeFileName(file)">修改</el-button>
                                        <el-button v-if="!readonly" type="text" @click="delFile(file)">
                                            <i class="el-icon-delete text-orange"></i></el-button>
                                    </div>
                                </div>
                                <div v-for="(item2,index2) in item1.folder" :key="index2" class="flex flex-direction radius">
                                    <el-divider v-if="(!item1.enclosure.length && index2 !==0 ) || item1.enclosure.length"></el-divider>
                                    <div class="document-name flex align-center justify-between padding-lr-sm">
                                        <div class="title text-df text-green">
                                            <i class="el-icon-folder-opened text-green text-bold margin-right-xs"></i>{{ item2.name
                                            }}
                                        </div>
                                        <div v-if="!readonly" class="flex align-center">
                                            <el-button class="btn small radius" size="small" type="primary" @click="addFiles(item2)">
                                                修改
                                            </el-button>
                                            <upload-file class="margin-lr-xs" :params="{pid: pid,did : item2.id}" multiple @uploadFile="uploadFile">
                                                <el-button slot="upload" class="btn small radius" size="small" type="primary">上传</el-button>
                                            </upload-file>
                                            <el-button class="btn small radius" size="small" type="danger" @click="delItemFiles(item2)">
                                                删除
                                            </el-button>
                                            <el-button class="btn small bg-red light radius" size="small" @click="downloadFiles(item2.id)">
                                                下载
                                            </el-button>
                                            <el-button class="btn small radius" size="small" @click="item2.expand = !item2.expand">
                                                {{ item2.expand ? '收起' : '展开' }}
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-divider v-if="item2.enclosure.length && item2.expand"></el-divider>
                                    <div class="margin-left-xl flex flex-direction" v-if="item2.expand">
                                        <div v-for="(file,position) in item2.enclosure" :key="position" class="file flex align-center justify-between padding-right-xl">
                                            <div class="flex-twice flex align-start justify-start">
                                                <div :href="file.file_url" class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                                    {{ file.name }}
                                                </div>
                                            </div>
                                            <div class="text-sm flex-sub">{{ file.create_time }}</div>
                                            <el-button v-if="!readonly" type="text" @click="changeFileName(file)">修改</el-button>
                                            <el-button v-if="!readonly" type="text" @click="delFile(file)">
                                                <i class="el-icon-delete text-orange"></i></el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--            <empty v-if="!lists.enclosure.length && !lists.folder.length" class="self-center"></empty>-->
        </div>
        <el-button v-if="(lists.enclosure.length || lists.folder.length) && (state === 0 || state === -2) && !readonly && !show" class="btn min bg-orange radius self-center margin-top-sm" type="warning" @click="submitItem()">
            提交审核
        </el-button>
        <div v-if="apply && state === 1" class="flex align-center justify-center margin-top">
            <el-button class="btn max bg-red radius " type="danger" @click="submitApplyed(false)">
                驳回
            </el-button>
            <el-button class="btn max bg-green radius margin-left-xl" type="success" @click="submitApplyed(true)">
                通过
            </el-button>
        </div>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`${tipAdd(cur_did)}文件夹`"
            :visible.sync="addFilesDialog"
            center
            width="400px">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label-width="0" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入文件名称"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">{{ tipAdd(cur_did) }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`拒绝原因`"
            :visible.sync="addReasonDialog"
            center
            width="400px">
            <el-form ref="ruleReasonForm" :model="ruleReasonForm" :rules="reason_rules" class="publish-form" label-width="100px">
                <el-form-item label-width="0" prop="reason">
                    <el-input v-model="ruleReasonForm.reason" :autosize="{ minRows: 3, maxRows: 3 }" placeholder="请输入" resize="none"
                              type="textarea">
                    </el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitReasonForm('ruleReasonForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`修改文件名`"
            :visible.sync="addFileNameDialog"
            center
            width="400px">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label-width="0" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入文件名称"></el-input>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitFileNameForm('ruleForm')">修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <export-loading :dialog-visible="exportFile" :p_id="pid" :pid="cur_pid" :type="file_type" @watchState="watchState"></export-loading>
    </div>
</template>

<script>

import {confirm,tipAdd, TOAST, toast} from "@/utils/utils";
import {
    addNoticeFile,
    applyProject,
    delNoticeFile,
    getApplyProjectNoticeFiles,
    getDownloadByMid,
    reSetFileName,
    submitApplyPro,
} from "@/api";
import UploadFile from "@/views/web/components/UploadFile";
import ExportLoading from "@/views/web/components/ExportLoading";
import {DOMAIN_HTTP} from "@/config";

export default {
    components: {ExportLoading, UploadFile},
    name: "ProjectNotice",
    data() {
        return {
            file_type:1,
            lists: {
                enclosure: [],
                folder: []
            },
            ruleForm: {
                name: '',
            },
            rules: {
                name: [
                    {required: true, message: '请输入文件名称', trigger: 'change'}
                ]
            },
            cur_did: 0,
            cur_parent_did: 0,
            addFilesDialog: false,
            ruleReasonForm: {
                reason: '',
            },
            reason_rules: {
                reason: [
                    {required: true, message: '请输入拒绝原因', trigger: 'change'}
                ]
            },
            addReasonDialog: false,
            addFileNameDialog: false,
            cur_pid:0,
            exportFile: false,
            expand: true,
            power: 0
        }
    },
    props: {
        pid: {
            type: Number,
            default: 0
        },
        state: {
            type: Number,
            default: 0
        },
        reason: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        apply: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        },
    },
    computed: {},
    created() {
        if (this.pid) this.init()
    },
    methods: {
        async init() {
            let _data = await getApplyProjectNoticeFiles(this.pid)
            _data.data.folder.map(item => {
                item.expand = true
                item.folder.map(item1 => {
                    item1.expand = true
                    item1.folder.map(item2 => {
                        item2.expand = true
                    })
                })
            })
            this.lists = _data.data

            _data = await getDownloadByMid(this.pid)
            this.power = _data.data.download
        },
        addFiles(data) {
            if (data) {
                this.cur_did = data.id
                this.cur_parent_did = data.parent_id
                this.ruleForm.name = data.name
            } else {
                this.cur_did = 0
                this.cur_parent_did = 0
                this.ruleForm.name = ''
            }
            this.addFilesDialog = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                }
            });
        },
        async submitInfo() {
            this.requesting = true
            let _data = await addNoticeFile(this.pid, this.cur_parent_did, 1, '', this.ruleForm.name, this.cur_did)
            if (_data.status === 200) {
                toast(`${tipAdd(this.cur_did)}成功`, TOAST.success)
                this.init()
                this.cancel()
            } else {
                toast(_data.msg, TOAST.error)
            }
            this.requesting = false
        },
        async submitApplyed(data) {
            if (data) {
                confirm(`提示`, `你确定通过嘛？`, () => {
                    this.submitReasonInfo(2)
                }, '确认', true)
            } else {
                this.addReasonDialog = true
            }
        },
        submitReasonForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitReasonInfo(-1, this.ruleReasonForm.reason)
                }
            });
        },
        async submitReasonInfo(state, reason = '') {
            let _data = await applyProject(this.pid, state, reason)
            if (_data.status === 200) {
                toast(`审核成功`, TOAST.success)
                this.cancel()
                this.$router.go(-1)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        delItemFiles(item) {
            confirm(`删除文件夹`, `你确定删除<b>${item.name}</b>文件夹及文件夹下的文件吗？`, () => {
                this.delFileItem(item.id)
            }, '确认', true)
        },
        delFile(item) {
            confirm(`删除文件`, `你确定删除<b>${item.name}</b>文件吗？`, () => {
                this.delFileItem(item.id)
            }, '确认', true)
        },
        async delFileItem(id) {
            let _data = await delNoticeFile(id)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        cancel() {
            this.addFilesDialog = false
            this.addReasonDialog = false
            this.addFileNameDialog = false
        },
        changeFileName(data) {
            if (data) {
                this.cur_did = data.id
                this.ruleForm.name = data.name
            }
            this.addFileNameDialog = true
        },
        submitFileNameForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.reSetFileName()
                }
            });
        },
        async reSetFileName() {
            let _data = await reSetFileName(this.cur_did, this.ruleForm.name, this.file_type)
            if (_data.status === 200) {
                toast(`修改成功`, TOAST.success)
                this.init()
                this.cancel()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        tipAdd(cur_did) {
            return tipAdd(cur_did)
        },
        //  上传成功
        uploadFile(data) {
            this.upFile(data.file.url, data.file.name,data.params)
        },
        async upFile(url, name,params) {
            let _data = await addNoticeFile(this.pid, params.new_wid || params.did,0, url, name)
            if (_data.status === 200) {
                toast(`上传成功`, TOAST.success)
                this.init()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },

        async uploadFiles(files, wid, pid) {
            this.cur_did = wid
            this.cur_parent_did = pid
            this.uping = this.$loading({
                lock: true,
                text: '上传中，请稍后',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.2)'
            });


        },
        submitItem() {
            confirm(`提交审核`, `你确定提交审核吗？`, () => {
                this.submitApply()
            }, '确认', true)
        },
        async submitApply() {
            let _data = await submitApplyPro(this.pid)
            if (_data.status === 200) {
                toast(`提交成功`, TOAST.success)
                this.next()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        next() {
            this.$emit('watchState', true)
        },
        watchState(){
            this.exportFile = false
        },
        async downloadFiles(id) {
            this.cur_pid = id
            this.exportFile = true
            // let _data = await downloadFiles(this.pid, id, 1)
            // if (_data.status === 200) {
            //     window.open(`${_data.data.url}&token=${this.$store.state.token}`)
            // } else {
            //     toast(_data.msg, TOAST.error)
            // }
        },
        previewFile(file) {
            const href =`${DOMAIN_HTTP}/file/preview?fid=${file.id}&type=${this.file_type}`
            window.open(href, '_blank')
        }
    },
    filters: {
        status(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 1 :
                    return '审核中'
                case -2 :
                    return '已拒绝'
                default:
                    return '已通过'
            }
        },
        status_color(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 1 :
                    return 'bg-orange'
                case -2 :
                    return 'bg-red'
                default:
                    return 'bg-green'
            }
        }
    },

    watch: {
        pid() {
            if (this.pid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    .status {
        padding: 12px 24px;
    }

    .document {
        border: solid 1px #e6e6e6;

        .document-name {
            height: 81px;
        }

        .file {
            height: 55px;
        }

        .file + .file {
            border-top: 1px solid var(--ghostWhite);
        }
    }
}
</style>